// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__Sloq4","logo":"PageHeader_logo__M6ZUR","title":"PageHeader_title__YDhmh","subtitle":"PageHeader_subtitle__9M7NJ"};